<nlr-plan-information [hidden]="selectedTab !== TABS.INFORMATION" />
<nlr-analysis [hidden]="selectedTab !== TABS.ANALYSIS" />
<nlr-interests [hidden]="selectedTab !== TABS.INTERESTS" />
<nlr-certification [hidden]="selectedTab !== TABS.CERTIFICATION" />
<nlr-lodge-plan [hidden]="selectedTab !== TABS.LODGE" />
<nlr-additionals [hidden]="selectedTab !== TABS.ADDITIONALS" />
<nlr-design [hidden]="selectedTab !== TABS.DESIGN" />
<nlr-digital-plan [hidden]="selectedTab !== TABS.DIGITAL_PLAN" />

@if (showDebugModels) {
    <div class="container-fluid debugger">
        <div
            class="btn-group"
            style="position:absolute;right:10px">
            @for (debugModelDisplayType of debugModelDisplayTypes; track debugModelDisplayType) {
                <button
                    type="button"
                    class="btn btn-default btn-sm"
                    (click)="onClickDebugModelDisplayType(debugModelDisplayType)"
                    [ngClass]="{active: selectedDebugModelDisplayTypes.includes(debugModelDisplayType)}"
                    style="z-index:1">
                    {{debugModelDisplayType}}
                </button>
            }
        </div>
        <div class="row">
            @for (selectedDebugModelDisplayType of selectedDebugModelDisplayTypes; track selectedDebugModelDisplayType) {
                <pre
                    style="position:relative;float:left;padding-left:15px;padding-right:15px"
                    [ngStyle]="{width: getDebugModelPreWidth()}"
                    >{{getDebugModel(selectedDebugModelDisplayType) | json :4}}
        </pre
                >
            }
        </div>
    </div>
}
